'use strict';

const validateVariant = require('../product/validateVarient');

/**
 * Update preview modal
 * @param {any} $modal - current modal
 */
function updatePersonalizationPreview($modal) {
    const $result = $('.js-personalization-text', $modal);
    const $checkedColor = $('.js-personalization-color:checked', $modal);
    const $colorLabelWrapper = $('.js-personalization-color-label-wrapper', $modal);
    const colorCSS = $('~ .color-label', $checkedColor).css('background-color');
    const colorID = $checkedColor.val();
    const colorLabel = $checkedColor.attr('data-label');
    const fontFamily = $('.js-personalization-font:checked', $modal).val();
    const dots = $('#personalizationDots', $modal).prop('checked');
    const position = $('.js-personalization-position:checked', $modal).attr('data-image-number') || '';
    const positionName = $('.js-personalization-position:checked', $modal).val();
    const $persoTextInput = $('#personalizationText', $modal);
    const $persoTextInputWrapper = $persoTextInput.closest('.js-text');
    const $labelTextSpan = $('label[for="personalizationText"] span', $modal);
    const $zoomImage = $('.js-zoom-image', $modal);
    const $nonZoomImage = $('.js-non-zoom-image', $modal);
    const lng = $modal.attr('data-lng');
    let text = $persoTextInput.val() || '';
    const mapFont = {
        round: 'Round',
        rounded: 'Round',
        grotesk: 'Grotesque',
        grotesque: 'Grotesque',
        script: 'Script',
    };
    const mapColor = {
        blind: 'black',
    };

    if (text) {
        $zoomImage.removeClass('d-none');
        $nonZoomImage.addClass('d-none');
    } else {
        $zoomImage.addClass('d-none');
        $nonZoomImage.removeClass('d-none');
    }

    if ($persoTextInputWrapper.hasClass('js-force-uppercase')) {
        text = text.toUpperCase();
        $persoTextInput.val(text);
    }

    if (positionName === 'clip') {
        $persoTextInput.attr('maxlength', 3);
        text = text.slice(0, 3);
        $persoTextInput.val(text);
        $labelTextSpan.html('3');
    } else if (positionName === 'cap') {
        $persoTextInput.attr('maxlength', 13);
        $labelTextSpan.html('13');
    }

    if (dots) {
        text = lng.match(/jp/i) ? text.replace(/^(.){1}/, '$1.') : text.split('').join('.');
    }
    if (position) {
        $('.js-personalization-preview-wrapper').addClass('d-none');
        $(`.js-personalization-preview-wrapper[data-image="${position}"]`).removeClass('d-none');
    }

    $colorLabelWrapper.html(colorLabel);

    let font = mapFont[fontFamily] || fontFamily || '';

    if ($modal.attr('data-3d-url')) {
        $('body').trigger('productPersonalization:updateText', {
            $iframe: $('iframe', $modal),
            position,
            text,
            font,
            color: colorID ? colorID.toUpperCase() : '',
        });
    } else {
        $result.html(text);
        $result.css({
            color: mapColor[colorID] || colorCSS,
            fontFamily: font,
            textShadow: $modal.attr('data-personalization-type') === 'embossing' ? '1px 0px 3px grey' : 'initial',
        });
    }
}

/**
 * Load personalization modal
 * @param {string} url - url to call
 */
async function loadModal(url) {
    return new Promise((resolve, reject) => {
        $.ajax({
            url,
            method: 'GET',
            success: function (data) {
                if ($('#productPersonalizationModal').length > 0) {
                    $('#productPersonalizationModal').remove();
                }
                $('body').append(data);
                const $modal = $('#productPersonalizationModal');

                updatePersonalizationPreview($modal);
                $modal.modal('show');

                // handle message from web GL iframe
                window.addEventListener(
                    'message',
                    (event) => {
                        try {
                            let msgData = JSON.parse(event.data);
                            if (msgData.iframeStates === 'SUCCESS' || msgData.displayZoomTips === 'FALSE') {
                                setTimeout(function () {
                                    updatePersonalizationPreview($modal);
                                }, 3000);
                            }
                        } catch (e) {
                            return false;
                        }
                        return true;
                    },
                    false
                );

                return resolve();
            },
            error: function () {
                return reject();
            },
        });
    });
}

/**
 * submit form to server
 * @param {*} $this - form node element
 * @param {string} uuid - UUID pli cart
 */
function submitPersonalizationForm($this, uuid) {
    const $modal = $this.closest('#productPersonalizationModal');
    let url = $this.attr('action');

    if (uuid) {
        url = url.replace('uuid=', 'uuid=' + uuid);
    }

    $.ajax({
        url,
        method: 'POST',
        data: $this.serialize(),
        success: function (response) {
            if (response.success && response.data) {
                const UUID = response.data.UUID;
                const persoData = response.personalizationData;
                const $context = $(`.js-lineitem-checkbox-wrapper[data-uuid="${UUID}"]`);
                const $input = $('.js-product-personalization-checkbox', $context);
                const $previewLineItem = $('.js-personalization-line-item-text', $context);

                $input.prop('checked', true);
                $previewLineItem.html(persoData.dots ? persoData.text.split('').join('.') : persoData.text);
                $previewLineItem.attr('data-font', persoData.font);

                $('body').trigger('gtm:add:event', response);
            }
            $modal.modal('hide');
        },
    });
}

module.exports = function () {
    $('body')
        .off('click', '.js-open-personalization-modal')
        .on('click', '.js-open-personalization-modal', function (e) {
            e.preventDefault();
            const $this = $(this);
            const url = $this.attr('data-url');

            const formError = validateVariant.validate($this, $this);

            if (!formError) {
                loadModal(url);
            }
        });

    $('body').on('change', '.js-product-personalization-checkbox', function () {
        const $this = $(this);
        const url = $this.attr('data-url');
        const currentVal = $this.prop('checked');

        // undo the effect, wait for the modal submit/close to happen
        $this.prop('checked', !currentVal);

        loadModal(url);
    });

    $('body').on('click', '.js-edit-personalization', function (e) {
        e.preventDefault();
        $(this).closest('.js-lineitem-checkbox-wrapper').find('.js-product-personalization-checkbox').prop('checked', false).trigger('change');
    });

    $('body').on('change keyup', '#productPersonalizationModal input, #productPersonalizationModal select', function () {
        const $modal = $('#productPersonalizationModal');
        updatePersonalizationPreview($modal);
    });

    $('body').on('submit', '#productPersonalizationModal form', function (e) {
        e.preventDefault();
        let isPersonalizationSubmitting = false;
        const $form = $(this);

        if (!$('#productPersonalizationModal').attr('data-uuid')) {
            // add product to cart then submit perso with pli uuid
            $('body').on('product:afterAddToCart', function (_, response) {
                if (!isPersonalizationSubmitting || !response.pliUUID) {
                    $('#productPersonalizationModal').modal('hide');
                    return;
                }
                isPersonalizationSubmitting = false;
                submitPersonalizationForm($form, response.pliUUID);
            });

            isPersonalizationSubmitting = true;
            let addToCartBtn = null;

            // The first implementation $('.product-detail .prices-add-to-cart-actions button.add-to-cart')  is returning two elements. When button is clicked,
            // it triggers two separate events, causing unexpected behavior (for example multiple GTM events).
            // To fix this, we need to specifically target the clicked button to ensure only one event is triggered.
            const $variationOverlay = $('.variations-overlay');
            if ($variationOverlay.hasClass('d-none')) {
                addToCartBtn = $('.product-detail .prices-add-to-cart-actions button.add-to-cart:not(.sticky-add-to-cart)');
            } else {
                addToCartBtn = $variationOverlay.find('button.add-to-cart');
            }

            addToCartBtn.click();
        } else {
            submitPersonalizationForm($form);
        }
    });

    $('body').on('product:personalizationSubmitting', function (e, { uuid }) {
        submitPersonalizationForm($('#productPersonalizationModal form'), uuid);
    });

    $('body')
        .off('click', '#productPersonalizationModal .js-remove-personalization')
        .on('click', '#productPersonalizationModal .js-remove-personalization', function (e) {
            const $this = $(this);
            const $modal = $this.closest('#productPersonalizationModal');
            e.preventDefault();
            const url = $(this).attr('data-remove-url');

            $.ajax({
                url,
                method: 'POST',
                success: function (data) {
                    if (data.success) {
                        const $input = $(`.js-lineitem-checkbox-wrapper[data-uuid="${data.UUID}"] .js-product-personalization-checkbox`);
                        $input.prop('checked', false);
                        $modal.modal('hide');
                    }
                },
            });
        });
};
